import { render, staticRenderFns } from "./TabDestino.vue?vue&type=template&id=34dbb3b8&"
import script from "./TabDestino.vue?vue&type=script&lang=js&"
export * from "./TabDestino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports